import React, { useId, useState } from 'react';
import { supabase } from '../../utils/supabaseClient';
import './ProductRequestCard.css';

function requestClientId() {
  let id;
  try { id = localStorage.getItem('ab-product-request-client'); } catch {}
  if (!/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(id || '')) {
    id = crypto.randomUUID();
    try { localStorage.setItem('ab-product-request-client', id); } catch {}
  }
  return id;
}

export default function ProductRequestCard() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [website, setWebsite] = useState('');
  const [state, setState] = useState('');
  const id = useId();
  async function submit(event) {
    event.preventDefault();
    if (state === 'sending') return;
    setState('sending');
    try {
      if (!supabase) throw new Error('unavailable');
      const { error } = await supabase.rpc('submit_product_request', {
        p_product_name: name.trim(), p_source_path: window.location.pathname,
        p_client_id: requestClientId(), p_website: website,
      });
      if (error) { setState(error.code === 'P0001' ? 'limited' : 'error'); return; }
      setState('success');
    } catch { setState('error'); }
  }
  return <aside className="ab-product-request" id="request-product" aria-label="Request a product">
    <span className="ab-product-request-plus" aria-hidden="true">+</span>
    <div className="ab-product-request-body"><h3>Missing a product?</h3><p>Tell us what you’d like to see. Help shape the gear we track.</p>
      {state === 'success' ? <p className="ab-product-request-success" role="status">Thanks! Your product request is saved for review.</p> : open ? <form onSubmit={submit}>
        <label htmlFor={id}>Product name</label>
        <div className="ab-product-request-fields"><input id={id} autoFocus value={name} onChange={e => setName(e.target.value)} minLength={3} maxLength={160} required placeholder="Brand and product name"/><button type="submit" disabled={state === 'sending'}>{state === 'sending' ? 'Sending…' : 'Request product'} <span aria-hidden="true">→</span></button></div>
        <label className="ab-request-honeypot" aria-hidden="true">Leave this empty<input name="company_website" value={website} onChange={e => setWebsite(e.target.value)} tabIndex={-1} autoComplete="off"/></label>
        {['error','limited'].includes(state) && <p role="alert">{state === 'limited' ? 'You’ve sent a few requests. Please try again in an hour.' : 'Your request could not be sent. Please try again.'}</p>}
      </form> : <button type="button" onClick={() => setOpen(true)}>Request a product <span aria-hidden="true">→</span></button>}
    </div>
  </aside>;
}
